import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import classplusLogo from "../../resources/ClassplusLogo.png";
import imgcross from '../../resources/imgcross.png';
import InfiniteScroll from 'react-infinite-scroll-component';
import './memories.css'

import { Loader } from 'semantic-ui-react'

function Memories(props) {
    const {Images,datalength,getApi,hasMore} = props;
    const [showImage,setShowImage] = useState(false)
    const [image,setImage] = useState()

    

    const [ mobileImageDisplay, setmobileImageDisplay ] = useState(props.Images[0].CreativeUrl)

    const clickImage = (image) => {
        console.log(image.target.src)
        setmobileImageDisplay(image.target.src)
        // setImage(image.target.src)
        // setShowImage(true)
    }
    // const imagess = [1,null];

    const addMemory = () => {
        props.history.push('/welcomePage');
    }

    return (
        <>
            <div className="web-navbar">
                <img src={classplusLogo} alt="" height="63px" width="120px"/>
            </div>

            <div className="web-memory-head">
                <div className="web-memory-left">
                    <div className="memory-left-heading">
                    India nae banayi <span className="teacher-name">{"400"} #ClassWaliDosti</span>
                    </div>
                    <div className="memory-left-subheading">
                    Banayien apni khud ki #ClassWaliDosti post aur share karien apne sabhi doston ke saath
                    </div>
                </div>
                <div className="web-memory-right">
                    <div className="post-button" onClick={()=> addMemory()}>
                        Create Your Memory
                    </div>
                    {/* <div className="createnew-button">
                        Create new one
                    </div> */}
                </div>
            </div>

            <div className="web-memory-mainImg">
                <img alt="" src={mobileImageDisplay} id="web-memory-mainImg-img" height="200px" width="200px"/>
            </div>

                <InfiniteScroll
                    
                    dataLength={Images.length}
                    next={()=>getApi()}
                    hasMore={hasMore}
                    loader={<h3>Loading...</h3>}
                    style={{
                        overflow: "visible"
                    }}
                    // scrollableTarget="web-memory-images"
                >
                    <div className="web-memory-images" id="web-memory-images">
                    {props.Images.map((image)=> {  
                        return (
                            <div className="memory-image-card">
                                <img className="memoryImage" src={image.CreativeUrl} alt="" height="246px" width="246px" onClick={(image)=>clickImage(image)}/>
                            </div>
                        )
                    })} 
                    </div>
                   
                </InfiniteScroll>


            <div className="web-memory-bottombuttons">
                    <div className="post-button" onClick={()=> addMemory()}>
                        Create your memory
                    </div>
                    {/* <div className="createnew-button">
                        Create new one
                    </div> */}
            </div>

            {showImage ? (
                <div className="image-view-background">
                    <div className="img-head" onClick={()=>setShowImage(false)}>
                        Close 

                    </div>
                    <div className="img-img" style={{marginTop:"16px"}}>
                        <img src={image} alt="" height="300px" width="300px" style={{border:"2px solid white",borderRadius:"5px"}}/>
                    </div>
                </div>
            ) : null}
        </>
    )
}

export default withRouter(Memories)
